<template>
  <pdl-label-group qaid="product-label-group">
    <pdl-label v-if="isArchived" kind="default" qaid="product-label-archive">
      <span v-html="bp('productArchivedFlag')" />
    </pdl-label>
    <pdl-label v-if="hasB2cSaleFlag" kind="critical" qaid="product-label-b2c-sale">
      <span v-html="bp('productSaleFlag')" />
    </pdl-label>
    <pdl-label v-if="hasB2bSaleFlag" kind="critical" qaid="product-label-b2b-sale">
      <span v-html="bp('productSaleFlag')" />
    </pdl-label>
    <pdl-label v-if="hasB2bEarlyIntroFlag" kind="default" qaid="product-label-b2b-early-intro">
      <span v-html="bp('productEarlyIntroFlag')" />
    </pdl-label>
    <pdl-label v-if="hasB2bCloseoutFlag" kind="important" qaid="product-label-b2b-closeout">
      <span v-html="bp('productCloseoutFlag')" />
    </pdl-label>
    <pdl-label v-if="hasProductCalloutNew" kind="default" qaid="product-label-callout-new">
      <span v-html="bp('productNewFlag')" />
    </pdl-label>
    <pdl-label v-if="hasProductCallout" kind="default" qaid="product-label-callout">
      <span v-html="product.productCallout" />
    </pdl-label>
  </pdl-label-group>
</template>
<script>
import {PdlLabel, PdlLabelGroup} from '@pedal/pdl-label';
export default {
  components: {
    PdlLabel,
    PdlLabelGroup,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    isB2bPdp: Boolean,
  },
  computed: {
    isArchived() {
      return !!this.product.isArchived;
    },
    hasB2cSaleFlag() {
      return !!(this.product.saleFlag && !this.isB2bPdp);
    },
    hasB2bSaleFlag() {
      return !!(this.isB2bPdp && this.product.productBadgeStatus == 'S');
    },
    hasB2bEarlyIntroFlag() {
      return !!(this.isB2bPdp && this.product.productBadgeStatus == 'E');
    },
    hasB2bCloseoutFlag() {
      return !!(this.isB2bPdp && this.product.productBadgeStatus == 'C');
    },
    hasProductCalloutNew() {
      return !!(
        this.product.productCallout &&
        this.product.productCallout.length > 0 &&
        this.product.productCallout.toLowerCase() === 'new'
      );
    },
    hasProductCallout() {
      return !!(
        this.product.productCallout &&
        this.product.productCallout.length > 0 &&
        !this.product.productCallout.toLowerCase() === 'new'
      );
    },
  },
};
</script>
